import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";

/**
 * GET /api/businesses – list businesses.
 * Params: all (admin), limit, offset, city (optional filter).
 * e.g. ?limit=20&offset=0&city=delhi | ?all=true&limit=50&offset=0
 */
export const callGetBusinessesApi = async (params = {}) => {
  const { data = {} } = await axiosInstanceClient.get(API.getBusinesses, {
    params,
  });
  return data;
};

/**
 * GET /api/users – list users for admin (filtering optional via params).
 */
export const callGetUsersApi = async (params = {}) => {
  const { data = {} } = await axiosInstanceClient.get(API.getUsers, {
    params,
  });
  return data;
};

/**
 * POST /api/users – create user.
 * For business user creation (role: business), response should include business_id
 * e.g. { business_id: number, user?: {...}, message?: string } or 201 with same in body.
 */
export const callPostUsersApi = async (payload = {}) => {
  const { data = {} } = await axiosInstanceClient.post(API.postUsers, payload);
  return data;
};